export default __webpack_public_path__ + "static/media/polyBeach.4a26ea25.png";